const skillsTech = [
  { type: 'Robotic Process Automation', level: 85 },
  { type: 'Blue Prism', level: 85 },
  { type: 'GitHub', level: 80 },
  { type: 'UNIX', level: 75 },
  { type: 'AWS', level: 75 },
  { type: 'Docker', level: 70 }
];

export default skillsTech;
